module.exports = __webpack_public_path__ + "img/900b_PAB_2021_InActionOutlookCheckmark.b4903656.png";